const locale = {
  es: {
    translation: {
      COMMUNITY_BLOG: 'Blog',
      COMMUNITY_PROJECTS: 'Proyectos',
      COMMUNITY_RESOURCES: 'Recursos',
      COMMUNITY_SCHOLARSHIPS: 'Becas',
      COMMUNITY_STORIES: 'Historias',
      COMMUNITY_TITLE: 'Comunidad',
      FOOTER_ABOUT: 'Sobre Crehana',
      FOOTER_ARCO: 'Solicitud de ARCO',
      FOOTER_COOKIES: 'Política de cookies',
      FOOTER_DOWNLOAD: 'Descarga nuestra app',
      FOOTER_DOWNLOAD_MOBILE: 'Descarga nuestra app en:',
      FOOTER_HELP: 'Ayuda',
      FOOTER_HIRING: '¡Estamos contratando!',
      FOOTER_MEET_US: 'Conócenos',
      FOOTER_PRIVACY: 'Políticas de privacidad',
      FOOTER_RIGHTS: 'Todos los derechos reservados',
      FOOTER_TERMS: 'Términos y condiciones',
      REMOTE_WORK: 'Trabajo Remoto',
      CREHANA_BUSINESS: 'Crehana para Empresas',
    },
  },
};

export default locale;
